import { Injectable } from '@angular/core';
import { SweetAlertOptions, SweetAlertResult, SweetAlertType } from 'sweetalert2';
import Swal from 'sweetalert2';
import { mapError } from 'app/utils/helpers';

@Injectable()
export class SweetAlertHelper {
  constructor() {}

  createCustomAlert(options: SweetAlertOptions): Promise<SweetAlertResult> {
    return Swal(options);
  }

  captureException(error, errorIsInHeader = false): Promise<SweetAlertResult> {
    let errorText: any;
    if (!error) { return; }

    if (errorIsInHeader) {
      const headers = error.headers;
      const messageException = headers.get('x-custom-header-filename');
      return this.throwErrorAlert(messageException);
    }

     if (mapError(error).length) {
       errorText = mapError(error).filter((item) => item);
     } else if (error.statusText) {
       errorText = error.statusText;
     } else if (error.message) {
       errorText = error.message;
     } else {
       errorText = error;
     }

    return this.throwErrorAlert(errorText);
  }

  captureExceptionList(error, title = 'Error', types: SweetAlertType = 'error'): Promise<SweetAlertResult> {
    const listaError: string[] = mapError(error).length
      ? mapError(error).filter((item) => item)
      : error.message;
    if (listaError) {
      return Swal({
        title: title,
        html: this.htmlResonse(listaError, error),
        type: types,
        showConfirmButton: true,
      });
    } else {
      return Swal({
        title: title,
        html: this.htmlResonse(error.split('\n'), error),
        type: types,
      });
    }
  }

  htmlResonse(listaError: string[], error: any) {
    return (
     '<div class="container height-200  scrollbar scrollbar-small"> ' +
        '<ul style="text-align: left;">' +
          listaError.map((item) => `<li>${item}</li>`).join('') +
        '</ul>' +
     '</div>' +

     `<div class='color-danger container margin-t-5 height-20 scrollbar scrollbar-small padding-b-10'>
      ${error.message ? error.message : ''}
      </div>`
    );
  }

  customAlertPayorInactive(payor: any) {
    if (payor && payor.agentemail && payor.agentname && payor.agentphone) {
      const agentEmail = payor.agentemail.split(';');
      Swal({
        title: 'Warning',
        html: `
        <p align='left' > <b> ${
          payor.description
        } is INACTIVE </b> please contact the agent </p>
        <p align='left' > <b> Name </b> :  ${payor.agentname} </p>
        <p align='left' > <b> Correo Electrónico: </b> </p>
        <ul>
        ${agentEmail
          .map(
            (email: string) =>
              `<li align='left' style='padding-left: 20px;' > ${email} </li>`
          )
          .join('')}
        </ul>
        <p align='left' > <b> Phone </b> :  ${payor.agentphone} </p>`,
        type: 'warning',
      });
    } else {
      Swal({
        title: 'Warning',
        html: `
        <p align='center'> <b> ${payor.description} is INACTIVE </b> please contact the agent </p>`,
        type: 'warning',
      });
    }
  }

  openModalActive(
    title: string,
    confirmButtonText = 'Save',
    cancelButtonText = 'Cancel'
  ): Promise<SweetAlertResult> {
    return Swal({
      title,
      input: 'text',
      showCancelButton: true,
      confirmButtonText,
      cancelButtonText,
      allowOutsideClick: true,
      onOpen: () => {
        Swal.disableConfirmButton();
        Swal.getInput().onkeyup = function (event: KeyboardEvent) {
          if (event.target['value']) {
            if (event.target['value'].trim() === '') {
              Swal.disableConfirmButton();
            } else {
              Swal.enableConfirmButton();
            }
          } else {
            Swal.disableConfirmButton();
          }
        };
      },
    });
  }

  throwErrorAlert(text: string) {
    return Swal({ title: 'Error', type: 'error', text  });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/helpers/sweet-alert-helper.service.ts